import React, {useEffect, useState, useRef} from 'react'
import {Link} from "react-router-dom";
import apiService from '../../../Services/apiServices'
import DataTable from '../../../PageComponents/UI/Tables/DataTable';
import helper from '../../../Services/helper';
import Select from "react-select"
import ExcelExport from '../../../PageComponents/Excel/ExcelExport';
import Search from '../../../PageComponents/Search/Search';
import AtkPurchaseBookHeader from './AtkPurchaseBookHeader';
import LoaderComponent from '../../../PageComponents/UI/Components/LoaderComponent';

const ReportAtkPurchaseBook = () => {
    const [data, setData] = useState([])
    const d = new Date();
    const searchObj = {CompanyBranch: 0, YEAR: d.getFullYear(), StartMonth: new Date().getMonth() + 1, EndMonth: new Date().getMonth() + 1}
    const [searchQuery, setSearchQuery] = useState(searchObj);
    const [loader , setLoader] = useState(false);
    const [vat0, setVat0] = useState([])
    const [vat18, setVat18] = useState([])
    const [vat8, setVat8] = useState([])
    const [filledTable, setFilledTable] = useState(false)
    const printRef = useRef();

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '28.59px',
            height: '28.59px',
            boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
            padding: '0 6px'
        }),
    
        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
        }),
    };
    
    const t = (key) => {
        return helper().translate(key);
    }
    const getDataPurchaseVat = async () => {
        var params = `purchaseOrSale=${0}`;

        await apiService().query('getSaleOrPurchase', params)
            .then((response) => {
                if(response.success) {
                    let d = response.data;
                    setVat0(d.filter(f => f.vat === 0))
                    setVat18(d.filter(f => f.vat === 18))
                    setVat8(d.filter(f => f.vat === 8))
                    setFilledTable(true)
                }
            })
    }

    const months = [
        {value: 1, label: t('JANUARY')},
        {value: 2, label: t('FEBRUARY')},
        {value: 3, label: t('MARCH')},
        {value: 4, label: t('APRILL')},
        {value: 5, label: t('MAY')},
        {value: 6, label: t('JUNE')},
        {value: 7, label: t('JULY')},
        {value: 8, label: t('AUGUST')},
        {value: 9, label: t('SEPTEMBER')},
        {value: 10, label: t('OCTOBER')},
        {value: 11, label: t('NOVEMBER')},
        {value: 12, label: t('DECEMBER')}
    ]
    const [years, setYears] = useState()

    const vat0Headers = vat0.map((item, key) => ({
        key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    }));
    
    const vat18Headers = vat18.map((item, key) => ({
        key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    }));
    const vat8Headers = vat8.map((item, key) => ({
        key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    }));

    const headers = [
        { key: 'Pos', columnName: 'Pos' , dontShowMenu : true  },
        { key: 'Id', columnName: 'ID' },
        { key: 'Date', columnName: t('DATE') },
        { key: 'InvoiceNo', columnName: t('INVOICE_NO') , type:"text"  },
        { key: 'CompanyName', columnName: t('COMPANY_NAME'), type:"text" },
        { key: 'FiscalNumber', columnName: t('FISCAL_NUMBER') },
        { key: 'VatNumber', columnName: t('VAT_NUMBER') },
        ...vat0Headers,
        ...vat18Headers,
        { key: 'K1', columnName: t('K1') , type: "number"},
        ...vat8Headers,
        { key: 'K2', columnName: t('K2') , type: "number"},
        { key: 'K67', columnName: t('K67'), type: "number" }
    ];

    const fillYears = () => {
        let s = d.getFullYear() - 10
        let e = d.getFullYear()
        let years = []

        for (let index = s; index <= e; index++) { 
            let obj = {value: index, label: index}
            years.push(obj)
        }
        setYears(years)
    }

    const getData = () => {
        setLoader(true);
        var params = `CompanyBranch=${searchQuery.CompanyBranch}&YEAR=${searchQuery.YEAR}&StartMonth=${searchQuery.StartMonth}&EndMonth=${searchQuery.EndMonth}`;

        apiService().query('RptAtkPurchaseBookNew', params)
            .then((response) => {
                if(response.success) {
                    setLoader(false);
                    let d = response.data;

                    d.forEach(d => {
                        d.Import ? d.InvoiceNo = d.DudNo : 0
                    })
                    setData(d)
                }
            })
    }

    const print = () => {
        //printRef.current.printPreview()
        window.open(`#/excel-print?CompanyBranch=${searchQuery.CompanyBranch}&YEAR=${searchQuery.YEAR}&StartMonth=${searchQuery.StartMonth}&EndMonth=${searchQuery.EndMonth}`, 'popUpWindow','height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
    }

    const exportToExcel = () => {
        let table = document.getElementById('table-to-xls-1').innerHTML;
        let fileName = helper().translate("ATK_PURCHASE_BOOK")
        return helper().exportToExcel(table, fileName)
    }

    useEffect(() => {
        getData()
        fillYears()
        getDataPurchaseVat()
    }, [])

    return (
        <div>
            <div className="container-fluid px-2 mt-3">
                {/* <Search search={false} excel={() => exportCsv(data, true)} printClick={print}/> */}
                <Search search={false} excel={() => exportToExcel()} printClick={print} back="#/reportsMap/2"/>
                <div className="card border-left-primary shadow mt-1 h-100 py-2">
                    <div className="card-body py-0">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2 row">
                            <div className="col-lg-3 form-group">
                                <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                {helper().translate("FROM")}
                                </label>
                                <Select styles={selectStyles} value={months?.find(m=> m.value === searchQuery.StartMonth)} options={months} onChange={(e) => { setSearchQuery({...searchQuery, StartMonth: e.value })}} />
                            </div>
                            <div className="col-lg-3 form-group">
                                <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                {helper().translate("TO")}
                                </label>
                            
                                <Select styles={selectStyles} value={months?.find(m=> m.value === searchQuery.EndMonth)} options={months} onChange={(e) => { setSearchQuery({...searchQuery, EndMonth: e.value })}} />
                            </div>
                            <div className="col-lg-3 form-group">
                                <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                {helper().translate("YEAR")}
                                </label>
                            
                                <Select styles={selectStyles} value={years?.find(y=> y.value === searchQuery.YEAR)} options={years} onChange={(e) => { setSearchQuery({...searchQuery, YEAR: e.value })}} />
                            </div>
                        </div>
                        <div className="col-auto">
                        <a className="searchbutton" onClick={getData}>
                            <i className="fas fa-search fa-2x text-dark"  />
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="card shadow mt-1">
                    <div className="card-header py-2">
                        <h6 className="m-0 font-weight-bold text-primary text-center">{helper().translate("ATK_PURCHASE_BOOK")}</h6>
                    </div>
                    {loader && <LoaderComponent /> } 
                    {!loader && filledTable ? <DataTable data={data.length ? data : []} headers={headers} /> : ""}
                    <div className='d-none'>
                        <div id="excelFile">
                            <ExcelExport data={data.length ? data : []} headers={headers.filter(header => header.key !== 'Id')} type={'purchase'} fileName={`Libri_Blerjes_Atk_${searchQuery.StartMonth}_${searchQuery.EndMonth}_${searchQuery.YEAR}`} zeroToNull={true}/>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default ReportAtkPurchaseBook
